/* eslint-disable */
import React from "react";
import { getPropertyQueries } from "../../../actions/appExpandedActions/properties";
import { connect } from "react-redux";
import DataTable from "../DataTable";
import { tablePresets } from "../DataTable/tablePresets";

const Services = ({ getPropertyQueries, propertyQueries, period }) => (
  <DataTable
    {...tablePresets.services}
    data={propertyQueries}
    fetchData={getPropertyQueries}
    period={period}
  />
);

const mapStateToProps = (state) => ({
  propertyQueries: state.appProperties.propertyQueries,
});

const mapDispatchToProps = (dispatch) => ({
  getPropertyQueries: (payload) => dispatch(getPropertyQueries(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Services);
